import { FC } from "react";
import { Button, Modal, Stack } from "react-bootstrap";

interface IGenericModal {
  show?: boolean;
  handleClose?: any;
  handleAction?: any;
  genericModalHeaderTitle?: any;
  genericModalBodyContent?: any;
  buttonName?: any;
  genericModalSize?: any;
  actionVariant?: string;
  actionDisabled?: boolean;
}

/**
 * Confirm Generic Modal Reusable Component
 *
 * @param {{ show: any; handleClose: any; handleAction: any; genericModalBodyContent: any; genericModalHeaderTitle: any; buttonName: any; genericModalSize?: string; }} param0
 * @param {*} param0.show
 * @param {*} param0.handleClose
 * @param {*} param0.handleAction
 * @param {*} param0.genericModalBodyContent
 * @param {*} param0.genericModalHeaderTitle
 * @param {*} param0.buttonName
 * @param {string} [param0.genericModalSize='sm']
 * @returns {*}
 */

const GenericModal: FC<IGenericModal> = ({
  show,
  handleClose,
  handleAction,
  genericModalBodyContent,
  genericModalHeaderTitle,
  buttonName,
  genericModalSize = "sm",
  actionVariant = "danger",
  actionDisabled = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered={true}
      //scrollable={true}
      size={genericModalSize}
      className="theme-modal rounded-4 delete-modal"
      enforceFocus={false}
    >
      {/* <Modal.Header closeButton>
                <Modal.Title as="h5" className="fw-semibold">{genericModalHeaderTitle || ''}</Modal.Title>
            </Modal.Header> */}

      <Modal.Body className=" text-break">{genericModalBodyContent}</Modal.Body>

      <Modal.Footer className="p-3 pt-0 border-0 justify-content-center">
        <Stack direction="horizontal" gap={3} className="flex-wrap py-1">
          <Button
            type="button"
            variant="outline-dark"
            onClick={handleClose}
            className="custom-min-width-120"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant={actionVariant}
            className="custom-min-width-120 text-white"
            onClick={handleAction}
            disabled={actionDisabled}
          >
            {buttonName ?? "Submit"}
          </Button>
        </Stack>
      </Modal.Footer>
    </Modal>
  );
};

export default GenericModal;
